import { Component } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';

import { SiteAddEdit } from "../component/features/sites/SiteAddEdit";
import SiteList from "../component/features/sites/SiteList";
import SiteDetail from "../component/features/sites/SiteDetail";

export class SiteRouter extends Component {
    
    render() {
        return (
            <Switch>
                <Route exact path={"/sites"} component={SiteList} />
                <Route exact path={`/sites/add`} component={SiteAddEdit} />
                <Route exact path={`/sites/edit/:id`} component={SiteAddEdit} />
                <Route exact path={`/sites/:id`} component={SiteDetail} />
                <Redirect to="/not-found" />
            </Switch>
        )
    }
};
